/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Reveal_TitleInputs */

const vi_api_keys_reveal_title = /** @type {(inputs: Api_Keys_Reveal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khóa API mới của bạn`)
};

/**

* @param {Api_Keys_Reveal_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_reveal_title = /** @type {((inputs?: Api_Keys_Reveal_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Reveal_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_reveal_title(inputs)
});